// @flow

export const DOCTOR_SEARCH_REQUEST = 'DOCTOR_SEARCH_REQUEST';
export const DOCTOR_SEARCHBAR_REQUEST = 'DOCTOR_SEARCHBAR_REQUEST';
export const DOCTOR_SEARCH_REQUESTED = 'DOCTOR_SEARCH_REQUESTED';
export const DOCTOR_SEARCHBAR_REQUESTED = 'DOCTOR_SEARCHBAR_REQUESTED';
export const DOCTOR_SEARCH_REQUESTED_ERROR = 'DOCTOR_SEARCH_REQUESTED_ERROR';
export const DOCTOR_SEARCH_RESET = 'DOCTOR_SEARCH_RESET';
export const PATIENT_SECOND_OPINION_BOOKING_REQUEST_DOCTORS = 'PATIENT_SECOND_OPINION_BOOKING_REQUEST_DOCTORS';

export const ITEMS_PER_PAGE = 24;
